import { trackEvent } from './analytics'

export const useTabTracking = (
  dispatch,
  actionContext,
  tabLabels,
  options = {},
) => {
  const resolveLabel = (value) => {
    if (typeof tabLabels === 'function') {
      return tabLabels(value)
    }
    if (tabLabels && typeof tabLabels === 'object') {
      return tabLabels[value] ?? value
    }
    return value
  }

  const handleChange = (event, newValue, onTabChange) => {
    // Track every tab click
    trackEvent(dispatch, {
      eventName: 'uxp_widget_tab_click',
      module: 'Dashboard',
      object: 'Widget',
      action: 'TabClick',
      actionContext,
      actionContextValue: resolveLabel(newValue),
      ...options,
    })

    // Call original tab change handler
    if (onTabChange) {
      onTabChange(newValue)
    }
  }

  return handleChange
}

export default useTabTracking
